const $document = $(document);
const $navigation = $('.js-navigation');
const $navigationToggle = $('.js-navigation-toggle');

$navigationToggle.on('click', () => {
  $navigation.toggleClass('is-toggled');
  $navigationToggle.toggleClass('is-toggled');
});
